// AUTO-GENERADO desde HorariosServicios19.08.26.xlsx (fuente de verdad). No editar a mano.

export const SERVICES = [
  {
    "id": "posadas-laplata",
    "upcoming": false,
    "directions": [
      {
        "from": "Posadas",
        "to": "La Plata",
        "departure": "15:15",
        "stops": [
          {
            "name": "Posadas",
            "time": "15:15"
          },
          {
            "name": "Ituzaingó",
            "time": "16:30"
          },
          {
            "name": "Loreto",
            "time": "17:30"
          },
          {
            "name": "San Miguel",
            "time": "18:00"
          },
          {
            "name": "Santa Rosa",
            "time": "18:45"
          },
          {
            "name": "Tabay",
            "time": "19:05"
          },
          {
            "name": "Tatacuá",
            "time": "19:15"
          },
          {
            "name": "Saladas",
            "time": "19:30"
          },
          {
            "name": "Acceso San Roque",
            "time": "20:00"
          },
          {
            "name": "Mantilla",
            "time": "20:15"
          },
          {
            "name": "9 de Julio",
            "time": "20:45"
          },
          {
            "name": "Acc. Chavarría",
            "time": "21:15"
          },
          {
            "name": "Mercedes (Corrientes)",
            "time": "22:00"
          },
          {
            "name": "Acc. Solari",
            "time": "22:30"
          },
          {
            "name": "Acc. Curuzú Cuatiá",
            "time": "23:00"
          },
          {
            "name": "Acc. Chajarí",
            "time": "23:45"
          },
          {
            "name": "Acc. Federación (Entre Ríos)",
            "time": "00:00"
          },
          {
            "name": "Acc. Concordia",
            "time": "00:30"
          },
          {
            "name": "Acc. Concepción Del Uruguay",
            "time": "01:30"
          },
          {
            "name": "Gualeguaychú",
            "time": "02:00"
          },
          {
            "name": "Zárate",
            "time": "04:30"
          },
          {
            "name": "Campana",
            "time": "04:50"
          },
          {
            "name": "Escobar",
            "time": "05:10"
          },
          {
            "name": "El Talar",
            "time": "05:30"
          },
          {
            "name": "Retiro",
            "time": "06:00"
          },
          {
            "name": "Quilmes",
            "time": "06:45"
          },
          {
            "name": "Cruce Varela",
            "time": "07:15"
          },
          {
            "name": "La Plata",
            "time": "07:45"
          }
        ]
      },
      {
        "from": "La Plata",
        "to": "Posadas",
        "departure": "14:45",
        "stops": [
          {
            "name": "La Plata",
            "time": "14:45"
          },
          {
            "name": "Cruce Varela",
            "time": "15:45"
          },
          {
            "name": "Quilmes",
            "time": "16:05"
          },
          {
            "name": "Retiro",
            "time": "16:45"
          },
          {
            "name": "El Talar",
            "time": "17:30"
          },
          {
            "name": "Escobar",
            "time": "17:50"
          },
          {
            "name": "Campana",
            "time": "18:10"
          },
          {
            "name": "Zárate",
            "time": "18:30"
          },
          {
            "name": "Gualeguaychú",
            "time": "19:45"
          },
          {
            "name": "Acc. Concepción Del Uruguay",
            "time": "20:45"
          },
          {
            "name": "Acc. Concordia",
            "time": "22:45"
          },
          {
            "name": "Acc. Federación (Entre Ríos)",
            "time": "23:15"
          },
          {
            "name": "Acc. Chajarí",
            "time": "23:30"
          },
          {
            "name": "Acc. Curuzú Cuatiá",
            "time": "01:00"
          },
          {
            "name": "Acc. Solari",
            "time": "01:30"
          },
          {
            "name": "Mercedes (Corrientes)",
            "time": "02:00"
          },
          {
            "name": "Acc. Chavarría",
            "time": "02:15"
          },
          {
            "name": "9 de Julio",
            "time": "02:45"
          },
          {
            "name": "Mantilla",
            "time": "03:00"
          },
          {
            "name": "Acceso San Roque",
            "time": "03:15"
          },
          {
            "name": "Saladas",
            "time": "03:45"
          },
          {
            "name": "Tatacuá",
            "time": "03:55"
          },
          {
            "name": "Tabay",
            "time": "04:05"
          },
          {
            "name": "Santa Rosa",
            "time": "04:30"
          },
          {
            "name": "San Miguel",
            "time": "05:15"
          },
          {
            "name": "Loreto",
            "time": "05:45"
          },
          {
            "name": "Ituzaingó",
            "time": "06:45"
          },
          {
            "name": "Posadas",
            "time": "08:00"
          }
        ]
      }
    ]
  },
  {
    "id": "clorinda-laplata",
    "upcoming": false,
    "directions": [
      {
        "from": "Clorinda",
        "to": "La Plata",
        "departure": "13:45",
        "stops": [
          {
            "name": "Clorinda",
            "time": "13:45"
          },
          {
            "name": "Formosa",
            "time": "15:45"
          },
          {
            "name": "Mansilla",
            "time": "16:45"
          },
          {
            "name": "Resistencia",
            "time": "18:15"
          },
          {
            "name": "Corrientes",
            "time": "19:00"
          },
          {
            "name": "Empedrado",
            "time": "19:45"
          },
          {
            "name": "Acc. San Lorenzo",
            "time": "20:00"
          },
          {
            "name": "4 Bocas Saladas",
            "time": "20:15"
          },
          {
            "name": "Bella Vista",
            "time": "21:10"
          },
          {
            "name": "Santa Lucía",
            "time": "21:45"
          },
          {
            "name": "Lavalle",
            "time": "21:52"
          },
          {
            "name": "Goya",
            "time": "22:30"
          },
          {
            "name": "Esquina",
            "time": "23:57"
          },
          {
            "name": "Acc. La Paz",
            "time": "01:00"
          },
          {
            "name": "Ruta 6 Y Rp 127",
            "time": "01:45"
          },
          {
            "name": "Ruta 6 Y R 18",
            "time": "02:45"
          },
          {
            "name": "Ruta 6 Y 39",
            "time": "03:30"
          },
          {
            "name": "Cinco Esquinas Y Gualeguay",
            "time": "04:45"
          },
          {
            "name": "Zárate",
            "time": "07:02"
          },
          {
            "name": "Campana",
            "time": "07:25"
          },
          {
            "name": "Escobar",
            "time": "07:55"
          },
          {
            "name": "El Talar",
            "time": "08:15"
          },
          {
            "name": "Retiro",
            "time": "09:00"
          },
          {
            "name": "Quilmes",
            "time": "10:00"
          },
          {
            "name": "Cruce Varela",
            "time": "10:15"
          },
          {
            "name": "La Plata",
            "time": "11:00"
          }
        ]
      },
      {
        "from": "La Plata",
        "to": "Clorinda",
        "departure": "13:00",
        "stops": [
          {
            "name": "La Plata",
            "time": "13:00"
          },
          {
            "name": "Cruce Varela",
            "time": "13:45"
          },
          {
            "name": "Quilmes",
            "time": "14:00"
          },
          {
            "name": "Retiro",
            "time": "15:00"
          },
          {
            "name": "El Talar",
            "time": "16:00"
          },
          {
            "name": "Escobar",
            "time": "16:05"
          },
          {
            "name": "Campana",
            "time": "16:35"
          },
          {
            "name": "Zárate",
            "time": "16:56"
          },
          {
            "name": "Cinco Esquinas Y Gualeguay",
            "time": "18:56"
          },
          {
            "name": "Ruta 6 Y 39",
            "time": "20:00"
          },
          {
            "name": "Ruta 6 Y R 18",
            "time": "21:00"
          },
          {
            "name": "Ruta 6 Y Rp 127",
            "time": "21:45"
          },
          {
            "name": "Acc. La Paz",
            "time": "22:30"
          },
          {
            "name": "Esquina",
            "time": "23:30"
          },
          {
            "name": "Goya",
            "time": "01:05"
          },
          {
            "name": "Santa Lucía",
            "time": "01:45"
          },
          {
            "name": "Bella Vista",
            "time": "02:15"
          },
          {
            "name": "4 Bocas Saladas",
            "time": "02:45"
          },
          {
            "name": "Acc. San Lorenzo",
            "time": "03:00"
          },
          {
            "name": "Empedrado",
            "time": "03:15"
          },
          {
            "name": "Corrientes",
            "time": "04:10"
          },
          {
            "name": "Resistencia",
            "time": "04:45"
          },
          {
            "name": "Mansilla",
            "time": "06:00"
          },
          {
            "name": "Formosa",
            "time": "07:00"
          },
          {
            "name": "Clorinda",
            "time": "09:00"
          }
        ]
      }
    ]
  },
  {
    "id": "rosario-obera",
    "upcoming": false,
    "directions": [
      {
        "from": "Oberá",
        "to": "Rosario",
        "departure": "12:40",
        "stops": [
          {
            "name": "Oberá",
            "time": "12:40"
          },
          {
            "name": "Leandro N. Alem",
            "time": "13:10"
          },
          {
            "name": "Posadas",
            "time": "14:30"
          },
          {
            "name": "Ituzaingó",
            "time": "15:45"
          },
          {
            "name": "Villa Olivari",
            "time": "16:15"
          },
          {
            "name": "Empalme R12 Y R18",
            "time": "16:30"
          },
          {
            "name": "Loreto",
            "time": "16:50"
          },
          {
            "name": "San Miguel",
            "time": "17:30"
          },
          {
            "name": "Paraje Caimán",
            "time": "18:00"
          },
          {
            "name": "Santa Rosa",
            "time": "18:20"
          },
          {
            "name": "Tabay",
            "time": "18:40"
          },
          {
            "name": "Tatacuá",
            "time": "18:50"
          },
          {
            "name": "Saladas",
            "time": "19:00"
          },
          {
            "name": "Bella Vista",
            "time": "20:00"
          },
          {
            "name": "Desmochado",
            "time": "20:30"
          },
          {
            "name": "Santa Lucía",
            "time": "21:00"
          },
          {
            "name": "Goya",
            "time": "21:30"
          },
          {
            "name": "Esquina",
            "time": "23:00"
          },
          {
            "name": "Acc. La Paz",
            "time": "00:00"
          },
          {
            "name": "Paraná",
            "time": "02:00"
          },
          {
            "name": "Santa Fe",
            "time": "02:45"
          },
          {
            "name": "Rosario",
            "time": "05:00"
          }
        ]
      },
      {
        "from": "Rosario",
        "to": "Oberá",
        "departure": "17:00",
        "stops": [
          {
            "name": "Rosario",
            "time": "17:00"
          },
          {
            "name": "Santa Fe",
            "time": "19:30"
          },
          {
            "name": "Paraná",
            "time": "20:15"
          },
          {
            "name": "Acc. La Paz",
            "time": "22:00"
          },
          {
            "name": "Esquina",
            "time": "23:00"
          },
          {
            "name": "Goya",
            "time": "00:30"
          },
          {
            "name": "Santa Lucía",
            "time": "01:00"
          },
          {
            "name": "Desmochado",
            "time": "01:30"
          },
          {
            "name": "Bella Vista",
            "time": "02:00"
          },
          {
            "name": "Saladas",
            "time": "03:00"
          },
          {
            "name": "Tatacuá",
            "time": "03:10"
          },
          {
            "name": "Tabay",
            "time": "03:20"
          },
          {
            "name": "Santa Rosa",
            "time": "03:40"
          },
          {
            "name": "Paraje Caimán",
            "time": "04:00"
          },
          {
            "name": "San Miguel",
            "time": "04:30"
          },
          {
            "name": "Loreto",
            "time": "05:10"
          },
          {
            "name": "Empalme R12 Y R18",
            "time": "05:30"
          },
          {
            "name": "Villa Olivari",
            "time": "05:45"
          },
          {
            "name": "Ituzaingó",
            "time": "06:15"
          },
          {
            "name": "Posadas",
            "time": "07:30"
          },
          {
            "name": "Leandro N. Alem",
            "time": "08:30"
          },
          {
            "name": "Oberá",
            "time": "09:00"
          }
        ]
      }
    ]
  },
  {
    "id": "posadas-sanvicente",
    "upcoming": false,
    "directions": [
      {
        "from": "Posadas",
        "to": "San Vicente",
        "departure": "10:45",
        "stops": [
          {
            "name": "Posadas",
            "time": "10:45"
          },
          {
            "name": "Candelaria",
            "time": "11:15"
          },
          {
            "name": "Santa Ana",
            "time": "11:35"
          },
          {
            "name": "San Ignacio",
            "time": "11:50"
          },
          {
            "name": "Gdor. Roca",
            "time": "12:00"
          },
          {
            "name": "Santo Pipó",
            "time": "12:10"
          },
          {
            "name": "Ñacanguazú",
            "time": "12:20"
          },
          {
            "name": "Hipólito Yrigoyen",
            "time": "12:25"
          },
          {
            "name": "Jardín América",
            "time": "12:30"
          },
          {
            "name": "Los Teales",
            "time": "12:40"
          },
          {
            "name": "Cuña Piru 2",
            "time": "12:45"
          },
          {
            "name": "Cuña Piru 1",
            "time": "12:55"
          },
          {
            "name": "Aristóbulo del Valle",
            "time": "13:20"
          },
          {
            "name": "Salto Encantado",
            "time": "13:30"
          },
          {
            "name": "Dos De Mayo",
            "time": "13:50"
          },
          {
            "name": "Km 237",
            "time": "13:55"
          },
          {
            "name": "Km 243",
            "time": "14:00"
          },
          {
            "name": "Km 251",
            "time": "14:05"
          },
          {
            "name": "San Vicente",
            "time": "14:30"
          }
        ]
      },
      {
        "from": "San Vicente",
        "to": "Posadas",
        "departure": "15:20",
        "stops": [
          {
            "name": "San Vicente",
            "time": "15:20"
          },
          {
            "name": "Km 251 (Dos De Mayo)",
            "time": "15:45"
          },
          {
            "name": "Km 243 (Dos De Mayo)",
            "time": "15:50"
          },
          {
            "name": "Km 237 (Dos De Mayo)",
            "time": "15:55"
          },
          {
            "name": "Dos De Mayo",
            "time": "16:00"
          },
          {
            "name": "Salto Encantado",
            "time": "16:15"
          },
          {
            "name": "Aristóbulo del Valle",
            "time": "16:30"
          },
          {
            "name": "Cuña Piru 1",
            "time": "16:55"
          },
          {
            "name": "Cuña Piru 2",
            "time": "17:05"
          },
          {
            "name": "Los Teales",
            "time": "17:10"
          },
          {
            "name": "Jardín América",
            "time": "17:20"
          },
          {
            "name": "Hipólito Yrigoyen",
            "time": "17:25"
          },
          {
            "name": "Ñacanguazú",
            "time": "17:30"
          },
          {
            "name": "Santo Pipó",
            "time": "17:40"
          },
          {
            "name": "Gdor. Roca",
            "time": "17:50"
          },
          {
            "name": "San Ignacio",
            "time": "18:00"
          },
          {
            "name": "Santa Ana",
            "time": "18:15"
          },
          {
            "name": "Candelaria",
            "time": "18:35"
          },
          {
            "name": "Posadas",
            "time": "19:05"
          }
        ]
      }
    ]
  },
  {
    "id": "posadas-iguazu",
    "upcoming": false,
    "directions": [
      {
        "from": "Posadas",
        "to": "Puerto Iguazú",
        "departure": "14:30",
        "stops": [
          {
            "name": "Posadas",
            "time": "14:30"
          },
          {
            "name": "Santa Ana",
            "time": "15:20"
          },
          {
            "name": "San Ignacio",
            "time": "15:40"
          },
          {
            "name": "Gdor. Roca",
            "time": "15:45"
          },
          {
            "name": "Santo Pipó",
            "time": "15:50"
          },
          {
            "name": "Ñacanguazú",
            "time": "15:55"
          },
          {
            "name": "Hipólito Yrigoyen",
            "time": "16:05"
          },
          {
            "name": "Jardín América",
            "time": "16:10"
          },
          {
            "name": "Puerto Leoni",
            "time": "16:20"
          },
          {
            "name": "Capioví",
            "time": "16:30"
          },
          {
            "name": "Puerto Rico",
            "time": "16:45"
          },
          {
            "name": "Garuhape",
            "time": "16:55"
          },
          {
            "name": "El Alcázar",
            "time": "17:05"
          },
          {
            "name": "Caraguatay",
            "time": "17:15"
          },
          {
            "name": "Montecarlo",
            "time": "17:25"
          },
          {
            "name": "Puerto Piray",
            "time": "17:35"
          },
          {
            "name": "Eldorado",
            "time": "17:45"
          },
          {
            "name": "Colonia Victoria",
            "time": "18:00"
          },
          {
            "name": "Colonia Magdalena",
            "time": "18:30"
          },
          {
            "name": "Puerto Esperanza",
            "time": "18:45"
          },
          {
            "name": "Wanda",
            "time": "19:00"
          },
          {
            "name": "Libertad",
            "time": "19:10"
          },
          {
            "name": "Bossetti",
            "time": "19:25"
          },
          {
            "name": "Puerto Iguazú",
            "time": "19:55"
          }
        ]
      },
      {
        "from": "Puerto Iguazú",
        "to": "Posadas",
        "departure": "20:40",
        "stops": [
          {
            "name": "Puerto Iguazú",
            "time": "20:40"
          },
          {
            "name": "Bossetti",
            "time": "21:10"
          },
          {
            "name": "Libertad",
            "time": "21:25"
          },
          {
            "name": "Wanda",
            "time": "21:35"
          },
          {
            "name": "Puerto Esperanza",
            "time": "21:50"
          },
          {
            "name": "Colonia Magdalena",
            "time": "22:05"
          },
          {
            "name": "Colonia Victoria",
            "time": "22:35"
          },
          {
            "name": "Eldorado",
            "time": "22:50"
          },
          {
            "name": "Puerto Piray",
            "time": "23:00"
          },
          {
            "name": "Montecarlo",
            "time": "23:10"
          },
          {
            "name": "Caraguatay",
            "time": "23:20"
          },
          {
            "name": "El Alcázar",
            "time": "23:30"
          },
          {
            "name": "Garuhape",
            "time": "23:40"
          },
          {
            "name": "Puerto Rico",
            "time": "23:50"
          },
          {
            "name": "Capioví",
            "time": "00:05"
          },
          {
            "name": "Puerto Leoni",
            "time": "00:15"
          },
          {
            "name": "Jardín América",
            "time": "00:25"
          },
          {
            "name": "Hipólito Yrigoyen",
            "time": "00:30"
          },
          {
            "name": "Ñacanguazú",
            "time": "00:40"
          },
          {
            "name": "Santo Pipó",
            "time": "00:45"
          },
          {
            "name": "Gdor. Roca",
            "time": "00:50"
          },
          {
            "name": "San Ignacio",
            "time": "00:55"
          },
          {
            "name": "Santa Ana",
            "time": "01:15"
          },
          {
            "name": "Posadas",
            "time": "02:05"
          }
        ]
      }
    ]
  },
  {
    "id": "iguazu-laplata",
    "upcoming": true,
    "directions": [
      {
        "from": "Puerto Iguazú",
        "to": "La Plata",
        "departure": "13:30",
        "stops": [
          {
            "name": "Puerto Iguazú",
            "time": "13:30"
          },
          {
            "name": "Wanda",
            "time": "14:10"
          },
          {
            "name": "Esperanza",
            "time": "14:40"
          },
          {
            "name": "El Dorado",
            "time": "15:10"
          },
          {
            "name": "Montecarlo",
            "time": "15:40"
          },
          {
            "name": "Puerto Rico",
            "time": "16:10"
          },
          {
            "name": "Capioví",
            "time": "16:40"
          },
          {
            "name": "Jardín América",
            "time": "17:00"
          },
          {
            "name": "San Ignacio",
            "time": "17:30"
          },
          {
            "name": "Santa Ana",
            "time": "17:50"
          },
          {
            "name": "Posadas",
            "time": "18:30"
          },
          {
            "name": "Virasoro",
            "time": "19:45"
          },
          {
            "name": "Santo Tomé (Axion)",
            "time": "20:30"
          },
          {
            "name": "Alvear",
            "time": "21:30"
          },
          {
            "name": "La Cruz (Acceso)",
            "time": "21:50"
          },
          {
            "name": "Yapeyú (Acceso)",
            "time": "22:40"
          },
          {
            "name": "Paso De Los Libres",
            "time": "23:30"
          },
          {
            "name": "Monte Caseros (Acceso)",
            "time": "00:50"
          },
          {
            "name": "Chajarí (Acceso)",
            "time": "01:00"
          },
          {
            "name": "Federación (Acceso)",
            "time": "01:20"
          },
          {
            "name": "Concordia (Acceso)",
            "time": "01:50"
          },
          {
            "name": "Concepción Del Uruguay (Acceso)",
            "time": "03:30"
          },
          {
            "name": "Gualeguaychú (La Posta)",
            "time": "04:10"
          },
          {
            "name": "Zárate (Rotonda)",
            "time": "05:20"
          },
          {
            "name": "Campana",
            "time": "05:40"
          },
          {
            "name": "Escobar",
            "time": "05:55"
          },
          {
            "name": "Talar 197",
            "time": "06:10"
          },
          {
            "name": "Retiro",
            "time": "06:45"
          },
          {
            "name": "Quilmes",
            "time": "07:30"
          },
          {
            "name": "Cruce Varela",
            "time": "07:50"
          },
          {
            "name": "La Plata",
            "time": "08:40"
          }
        ]
      },
      {
        "from": "La Plata",
        "to": "Puerto Iguazú",
        "departure": "11:15",
        "stops": [
          {
            "name": "La Plata",
            "time": "11:15"
          },
          {
            "name": "Cruce Varela",
            "time": "12:15"
          },
          {
            "name": "Quilmes",
            "time": "12:35"
          },
          {
            "name": "Retiro",
            "time": "13:15"
          },
          {
            "name": "Talar 197",
            "time": "14:00"
          },
          {
            "name": "Escobar",
            "time": "14:15"
          },
          {
            "name": "Campana",
            "time": "14:30"
          },
          {
            "name": "Zárate (Rotonda)",
            "time": "14:50"
          },
          {
            "name": "Gualeguaychú (La Posta)",
            "time": "16:10"
          },
          {
            "name": "Concepción Del Uruguay (Acceso)",
            "time": "17:10"
          },
          {
            "name": "Concordia (Acceso)",
            "time": "19:00"
          },
          {
            "name": "Federación (Acceso)",
            "time": "19:30"
          },
          {
            "name": "Chajarí (Acceso)",
            "time": "19:50"
          },
          {
            "name": "Monte Caseros (Acceso)",
            "time": "20:00"
          },
          {
            "name": "Paso De Los Libres",
            "time": "21:20"
          },
          {
            "name": "Yapeyú (Acceso)",
            "time": "22:00"
          },
          {
            "name": "La Cruz (Acceso)",
            "time": "22:50"
          },
          {
            "name": "Alvear",
            "time": "23:10"
          },
          {
            "name": "Santo Tomé (Axion)",
            "time": "00:20"
          },
          {
            "name": "Virasoro",
            "time": "00:50"
          },
          {
            "name": "Posadas",
            "time": "02:10"
          },
          {
            "name": "Santa Ana",
            "time": "02:30"
          },
          {
            "name": "San Ignacio",
            "time": "03:00"
          },
          {
            "name": "Jardín América",
            "time": "03:30"
          },
          {
            "name": "Capioví",
            "time": "03:50"
          },
          {
            "name": "Puerto Rico",
            "time": "04:20"
          },
          {
            "name": "Montecarlo",
            "time": "05:00"
          },
          {
            "name": "El Dorado",
            "time": "05:30"
          },
          {
            "name": "Esperanza",
            "time": "05:50"
          },
          {
            "name": "Wanda",
            "time": "06:10"
          },
          {
            "name": "Puerto Iguazú",
            "time": "06:30"
          }
        ]
      }
    ]
  }
];

// Servicios (por dirección) cuya CABECERA (origen o destino) es la ciudad.
export const servicesForCity = (city) => {
  const out = [];
  for (const s of SERVICES) {
    for (const d of s.directions) {
      if (d.from === city || d.to === city) {
        out.push({ ...d, upcoming: s.upcoming, serviceId: s.id });
      }
    }
  }
  // Salidas desde la ciudad primero, luego llegadas
  out.sort((a, b) => (a.from === city ? 0 : 1) - (b.from === city ? 0 : 1));
  return out;
};
